import { RsAction, RsActions } from '../rsActions';
import { AntragsummerGenerated } from '../action-types/antragsummerGenerated';

export const antragsnummerReducer = function (
  sectionState: string = null,
  action: RsAction<AntragsummerGenerated>,
): string {
  switch (action.type) {
    case RsActions.ANTRAGSNUMMER_GENERATED: {
      return action.payload.antragsnummer;
    }
    default:
      return sectionState;
  }
};
